import { useRoutes } from 'react-router-dom';

import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import OtherRoutes from './OtherRoutes';

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, ...AuthRoutes, OtherRoutes]);
}
